import { createReducer } from '@reduxjs/toolkit';
import { DemandOrderDto, ReturnOrderDto } from '../../api/ClientApi';

import {
    clearOrderForOrderDetails,
    importDemandOrderForOrderDetails,
    importReturnOrderForOrderDetails,
    removeDemandOrderForOrderDetails,
    removeReturnOrderForOrderDetails,
    updateDemandOrderForOrderDetails,
    updateReturnOrderForOrderDetails,
} from '../actions/orderActions';

export interface OrderDetailsReducerState {
    demandOrder: DemandOrderDto | null;
    returnOrder: ReturnOrderDto | null;
}

function clearState(state: OrderDetailsReducerState): void {
    state.demandOrder = null;
    state.returnOrder = null;
}

function getInitialState(): OrderDetailsReducerState {
    const state: OrderDetailsReducerState = {
        demandOrder: null,
        returnOrder: null,
    };

    clearState(state);

    return state;
}

export const orderDetailsReducer = createReducer<OrderDetailsReducerState>(
    getInitialState(), // Initial state
    (builder) => {
        builder
            .addCase(importDemandOrderForOrderDetails.fulfilled, (state: OrderDetailsReducerState, action: any) => {
                const newOrder = action.payload as DemandOrderDto;

                state.demandOrder = newOrder;
            })
            .addCase(importReturnOrderForOrderDetails.fulfilled, (state: OrderDetailsReducerState, action: any) => {
                const newOrder = action.payload as ReturnOrderDto;

                state.returnOrder = newOrder;
            })
            .addCase(clearOrderForOrderDetails, (state: OrderDetailsReducerState, action: any) => {
                clearState(state);
            })
            .addCase(updateDemandOrderForOrderDetails, (state: OrderDetailsReducerState, action: any) => {
                const newOrder = action.payload as DemandOrderDto;

                if (newOrder.id === state.demandOrder?.id) {
                    state.demandOrder = newOrder;
                }
            })
            .addCase(updateReturnOrderForOrderDetails, (state: OrderDetailsReducerState, action: any) => {
                const newOrder = action.payload as ReturnOrderDto;

                if (newOrder.id === state.returnOrder?.id) {
                    state.returnOrder = newOrder;
                }
            })
            .addCase(removeDemandOrderForOrderDetails, (state: OrderDetailsReducerState, action: any) => {
                state.demandOrder = null;
            })
            .addCase(removeReturnOrderForOrderDetails, (state: OrderDetailsReducerState, action: any) => {
                state.returnOrder = null;
            });
    },
);
